import produce from 'immer';

import {
  FETCH_SUBMISSION_TAGS_LIST_FAILURE,
  FETCH_SUBMISSION_TAGS_LIST_SUCCESS,
  FETCH_TAGS_LIST_FAILURE,
  FETCH_TAGS_LIST_SUCCESS,
  LOAD_MORE_SUBMISSION_TAGS,
  LOAD_MORE_TAGS,
} from '@actions/tag';

const initialState: ITagStore = {
  tagList: null,
  submissionTagList: null,
  isFetching: false,
  error: null,
};

export default (state: ITagStore = initialState, action: any) =>
  produce(state, (draftState: ITagStore) => {
    switch (action.type) {
      case FETCH_TAGS_LIST_SUCCESS:
        draftState.tagList = action.response;
        draftState.error = null;

        return;

      case LOAD_MORE_TAGS:
        const { data, selectedTags } = action.response;
        draftState.tagList.data = draftState.tagList.data.concat(data);
        draftState.tagList.selectedTags = selectedTags;
        draftState.error = null;

        return;

      case FETCH_TAGS_LIST_FAILURE:
        draftState.tagList = null;
        draftState.error = action.error;

        return;

      case FETCH_SUBMISSION_TAGS_LIST_SUCCESS:
        draftState.submissionTagList = action.response;
        draftState.error = null;

        return;

      case LOAD_MORE_SUBMISSION_TAGS:
        const tagData = action.response.data;
        // tslint:disable-next-line: max-line-length
        draftState.submissionTagList.data = draftState.submissionTagList.data.concat(tagData);
        draftState.error = null;

        return;

      case FETCH_SUBMISSION_TAGS_LIST_FAILURE:
        draftState.submissionTagList = null;
        draftState.error = action.error;

        return;
    }
  });
